module.exports = __webpack_public_path__ + "static/media/extractive_services_law.5acf56d2.svg";